module.exports = __webpack_public_path__ + "img/stock5.66e9efa3.png";